"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Graphics;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CommonContentModule = _interopRequireDefault(require("../CommonContent.module.scss"));

var _GraphicsModule = _interopRequireDefault(require("./Graphics.module.scss"));

var _inputElements = require("../../../../../inputElements");

var _ListElement = _interopRequireDefault(require("../../../../../common/ListElement/ListElement"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var resolutionOptions = [{
  value: "1024*768*16",
  label: "1024*768*16"
}, {
  value: "1024*768*32",
  label: "1024*768*32"
}, {
  value: "1920*1080*16",
  label: "1920*1080*16"
}, {
  value: "1920*1080*3",
  label: "1920*1080*3"
}];

function Graphics(_ref) {
  var className = _ref.className;

  var _useState = (0, _react.useState)(resolutionOptions.find(function (o) {
    return o.value === "1920*1080*3";
  })),
      _useState2 = _slicedToArray(_useState, 2),
      selectOption = _useState2[0],
      setSelectOption = _useState2[1];

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_CommonContentModule.default.content, _GraphicsModule.default.content, className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _GraphicsModule.default.entries
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _GraphicsModule.default.primary
  }, /*#__PURE__*/_react.default.createElement("table", null, /*#__PURE__*/_react.default.createElement("tbody", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.listElement
  }, /*#__PURE__*/_react.default.createElement(_ListElement.default, {
    color: "red"
  })), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.label
  }, "Brightness"), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.value
  }, /*#__PURE__*/_react.default.createElement(_inputElements.Slider, {
    initialValue: 50,
    inStepsOfTen: true
  }))), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.listElement
  }, /*#__PURE__*/_react.default.createElement(_ListElement.default, {
    color: "red"
  })), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.label
  }, "Resolution"), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.value
  }, /*#__PURE__*/_react.default.createElement(_inputElements.Select, {
    options: resolutionOptions,
    defaultValue: selectOption,
    onChange: function onChange(entry) {
      return setSelectOption(resolutionOptions.find(function (o) {
        return (o === null || o === void 0 ? void 0 : o.value) === (entry === null || entry === void 0 ? void 0 : entry.value);
      }));
    }
  })))))), /*#__PURE__*/_react.default.createElement("div", {
    className: _GraphicsModule.default.secondary
  }, /*#__PURE__*/_react.default.createElement("table", null, /*#__PURE__*/_react.default.createElement("tbody", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.listElement
  }, /*#__PURE__*/_react.default.createElement(_ListElement.default, null)), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.label
  }, "Grass"), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.btnLeft
  }), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.value
  }, /*#__PURE__*/_react.default.createElement(_inputElements.Checkbox, {
    type: "OPTION_BTN"
  })), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.btnRight
  })), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.listElement
  }, /*#__PURE__*/_react.default.createElement(_ListElement.default, null)), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.label
  }, "Texture (Terrain)"), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.btnLeft
  }, /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.LEFT_ARROW
  })), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.value
  }, "Hight"), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.btnRight
  }, /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.RIGHT_ARROW
  }))), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.listElement
  }, /*#__PURE__*/_react.default.createElement(_ListElement.default, null)), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.label
  }, "Texture (Char)"), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.btnLeft
  }, /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.LEFT_ARROW
  })), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.value
  }, "Hight"), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.btnRight
  }, /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.RIGHT_ARROW
  }))), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.listElement
  }, /*#__PURE__*/_react.default.createElement(_ListElement.default, null)), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.label
  }, "Range (Terrain)"), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.btnLeft
  }, /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.LEFT_ARROW
  })), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.value
  }, "Medium"), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.btnRight
  }, /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.RIGHT_ARROW
  }))), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.listElement
  }, /*#__PURE__*/_react.default.createElement(_ListElement.default, null)), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.label
  }, "Range (Char)"), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.btnLeft
  }, /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.LEFT_ARROW
  })), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.value
  }, "Low"), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.btnRight
  }, /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.RIGHT_ARROW
  }))), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.listElement
  }, /*#__PURE__*/_react.default.createElement(_ListElement.default, null)), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.label
  }, "Reflections"), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.btnLeft
  }, /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.LEFT_ARROW
  })), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.value
  }, "1"), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.btnRight
  }, /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.RIGHT_ARROW
  }))), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.listElement
  }, /*#__PURE__*/_react.default.createElement(_ListElement.default, null)), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.label
  }, "Magic Effects"), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.btnLeft
  }, /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.LEFT_ARROW
  })), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.value
  }, "All"), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.btnRight
  }, /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.RIGHT_ARROW
  }))), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.listElement
  }, /*#__PURE__*/_react.default.createElement(_ListElement.default, null)), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.label
  }, "Shadow"), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.btnLeft
  }, /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.LEFT_ARROW
  })), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.value
  }, "Myself"), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.btnRight
  }, /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.RIGHT_ARROW
  }))), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.listElement
  }, /*#__PURE__*/_react.default.createElement(_ListElement.default, null)), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.label
  }, "Name"), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.btnLeft
  }, /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.LEFT_ARROW
  })), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.value
  }, "None"), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.btnRight
  }, /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.RIGHT_ARROW
  }))), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.listElement
  }, /*#__PURE__*/_react.default.createElement(_ListElement.default, null)), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.label
  }, "Filtering Effect"), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.btnLeft
  }, /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.LEFT_ARROW
  })), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.value
  }, "No"), /*#__PURE__*/_react.default.createElement("td", {
    className: _GraphicsModule.default.btnRight
  }, /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.RIGHT_ARROW
  }))))))), /*#__PURE__*/_react.default.createElement("div", {
    className: _CommonContentModule.default.buttonFooter
  }, /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.OPTION
  }, "Reset"), /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.OPTION
  }, "Ok")));
}